import styled, { css } from 'styled-components';
import { FlexibleDiv } from '../../../../../styled/common';

const borderBottomStyled = css`
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.primary};
`;

export const CheckBoxListDropdownMain = styled(FlexibleDiv)<{
  hasBottomBottom: boolean;
}>`
  height: 55px;
  align-items: center;

  ${({ hasBottomBottom }) => hasBottomBottom && borderBottomStyled}
`;

export const CheckBoxWrapper = styled.div<{ isLastChild: boolean }>`
  ${({ isLastChild }) => isLastChild && borderBottomStyled}
`;
